var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgSlack = function SvgSlack(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 22.5A3.75 3.75 0 1 0 36 18.75v3.75h3.75Zm-10.5 0A3.75 3.75 0 0 0 33 18.75V8.25a3.75 3.75 0 1 0-7.5 0v10.5a3.75 3.75 0 0 0 3.75 3.75Z",
    fill: "#2EB67D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 25.5A3.75 3.75 0 1 0 12 29.25V25.5H8.25Zm10.5 0A3.75 3.75 0 0 0 15 29.25v10.5a3.75 3.75 0 1 0 7.5 0v-10.5a3.75 3.75 0 0 0-3.75-3.75Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 39.75A3.75 3.75 0 1 0 29.25 36H25.5v3.75Zm0-10.5A3.75 3.75 0 0 0 29.25 33h10.5a3.75 3.75 0 1 0 0-7.5h-10.5a3.75 3.75 0 0 0-3.75 3.75Z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.25A3.75 3.75 0 1 0 18.75 12h3.75V8.25Zm0 10.5A3.75 3.75 0 0 0 18.75 15H8.25a3.75 3.75 0 1 0 0 7.5h10.5a3.75 3.75 0 0 0 3.75-3.75Z",
    fill: "#36C5F0"
  })));
};

export default SvgSlack;